module.exports = __webpack_public_path__ + "img/index-slide-13.7e816e8d.png";